import ImageGallery from "../ImageGallery";
import React from "react";

import ConsignmentImageType from "../common/enum/ConsignmentImageType";
import API from "../../services/API";


interface ConsignmentImagesGalleryProps {
    consignment: CustomerAPIConsignmentResponse
    hidden: boolean
}

const ConsignmentImagesGallery = (props: ConsignmentImagesGalleryProps) => {

    const formatTitle = (image: CustomerAPIImage) => {
        const imageKind = ConsignmentImageType.valueOf(image.kind);
        if (imageKind) {
            return <>{imageKind.description}<br /> {image.formattedCreatedAt}</>
        }
        return image.formattedCreatedAt;
    };

    const { images } = props.consignment;

    if (images.length < 1 || props.hidden) {
        return null;
    }

    return (
        <div>
            <h5>Delivery Photos</h5>

            <ImageGallery
                images={images.map(image => ({
                    src: `${API.ORIGIN}/customer/v1/consignments/${props.consignment.id}/images/${image.id}`,
                    title: formatTitle(image),
                    description: image.comments || " "
                }))}
            />

        </div>
    )

}

export default ConsignmentImagesGallery;
